import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "settings-card" }
const _hoisted_2 = { class: "settings-card__header" }
const _hoisted_3 = { class: "settings-card__title" }
const _hoisted_4 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-info ms-auto",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "settings-card__body" }
const _hoisted_6 = { class: "msg-table-scroll" }
const _hoisted_7 = { class: "msg-header-row" }
const _hoisted_8 = { class: "msg-col msg-col-name" }
const _hoisted_9 = { class: "msg-col msg-col-comment" }
const _hoisted_10 = { class: "msg-col msg-col-message" }
const _hoisted_11 = { class: "msg-col msg-col-status" }
const _hoisted_12 = { class: "msg-col msg-col-actions" }
const _hoisted_13 = { class: "msg-group" }
const _hoisted_14 = { class: "msg-group-heading" }
const _hoisted_15 = { class: "msg-group-title" }
const _hoisted_16 = ["title"]
const _hoisted_17 = ["title"]
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "msg-col msg-col-status" }
const _hoisted_20 = { class: "form-check form-switch settings-switch mb-0" }
const _hoisted_21 = ["checked", "disabled", "onChange"]
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-secondary ms-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_23 = { class: "msg-col msg-col-actions" }
const _hoisted_24 = ["data-bs-target"]
const _hoisted_25 = { class: "msg-group" }
const _hoisted_26 = { class: "msg-group-heading" }
const _hoisted_27 = { class: "msg-group-title" }
const _hoisted_28 = ["title"]
const _hoisted_29 = ["title"]
const _hoisted_30 = ["title"]
const _hoisted_31 = { class: "msg-col msg-col-status" }
const _hoisted_32 = { class: "form-check form-switch settings-switch mb-0" }
const _hoisted_33 = ["checked", "disabled", "onChange"]
const _hoisted_34 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-secondary ms-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_35 = { class: "msg-col msg-col-actions" }
const _hoisted_36 = ["data-bs-target"]

import {computed, onMounted, ref} from 'vue'
import SettingsRepository from '@/repositories/SettingsRepository'
import {SettingsMessageInterface} from '@/types/SettingsMessagesInterface'
import ToastService from '@/services/ToastService'
import i18n from '@/plugins/i18n'
import EditModal from '@/views/settings/messages/Edit.vue'
import {Constants} from '@/constants/Constants'


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const messages = ref<SettingsMessageInterface[]>([])
const loading = ref(false)
const busy = ref<Record<string, boolean>>({})

onMounted(async () => {
  await updateMessages()
})

const updateMessages = async () => {
  loading.value = true
  messages.value = await SettingsRepository.getMessages().finally(() => { loading.value = false })
}

const confirmationMessages = computed(() => {
  return messages.value.filter((message) => {
    return Constants.CONFIRMATIONS.includes(message.id)
  })
})

const chatBotMessages = computed(() => {
  return messages.value.filter((message) => {
    return !Constants.CONFIRMATIONS.includes(message.id)
  })
})

const toggleMessage = async (message: SettingsMessageInterface): Promise<void> => {
  busy.value[message.id] = true
  message.enabled = !message.enabled
  SettingsRepository.updateMessage(message)
    .then(async () => {
      const statusMessage = message.enabled
        ? i18n.global.t('common.fields.enabled')
        : i18n.global.t('common.fields.disabled')
      await ToastService.toast(ToastService.SUCCESS, statusMessage)
    })
    .catch(async (error) => {
      await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), error.message)
    })
    .finally(() => {
      delete busy.value[message.id]
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "settings-icon-chip settings-icon-chip--whatsapp" }, [
        _createElementVNode("em", { class: "fa-brands fa-whatsapp" })
      ], -1)),
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$t('common.titles.title_card')), 1),
      (loading.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('services.fields.name')), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('services.fields.comment')), 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('services.fields.WpMessages')), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('common.fields.status')), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('services.fields.WpActions')), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "msg-group-icon msg-group-icon--success" }, [
              _createElementVNode("em", { class: "fas fa-check-double" })
            ], -1)),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('wp.titles.confirmations_messages')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(confirmationMessages.value, (message, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["msg-row", { 'msg-row--alt': index % 2 === 1 }]),
              key: index
            }, [
              _createVNode(EditModal, {
                selectedMessage: message,
                onUpdateMessages: updateMessages
              }, null, 8, ["selectedMessage"]),
              _createElementVNode("div", {
                class: "msg-col msg-col-name",
                title: message.name
              }, _toDisplayString(message.name), 9, _hoisted_16),
              _createElementVNode("div", {
                class: "msg-col msg-col-comment",
                title: message.description
              }, _toDisplayString(message.description), 9, _hoisted_17),
              _createElementVNode("div", {
                class: "msg-col msg-col-message",
                title: message.message
              }, _toDisplayString(message.message), 9, _hoisted_18),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    name: "enable",
                    type: "checkbox",
                    checked: message.enabled,
                    disabled: busy.value[message.id],
                    onChange: ($event: any) => (toggleMessage(message))
                  }, null, 40, _hoisted_21)
                ]),
                (busy.value[message.id])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: _normalizeClass(["gorda-status-badge", message.enabled ? 'gorda-status-badge--success' : 'gorda-status-badge--danger'])
                }, _toDisplayString(_ctx.$t(message.enabled ?
                  'common.fields.enabled' : 'common.fields.disabled')), 3)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "settings-icon-btn",
                  "data-bs-toggle": "modal",
                  "data-bs-target": '#' + message.id
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                ]))], 8, _hoisted_24)
              ])
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "msg-group-icon msg-group-icon--info" }, [
              _createElementVNode("em", { class: "fas fa-robot" })
            ], -1)),
            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('wp.titles.chatbot_messages')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatBotMessages.value, (message, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["msg-row", { 'msg-row--alt': index % 2 === 1 }]),
              key: index
            }, [
              _createVNode(EditModal, {
                selectedMessage: message,
                onUpdateMessages: updateMessages
              }, null, 8, ["selectedMessage"]),
              _createElementVNode("div", {
                class: "msg-col msg-col-name",
                title: message.name
              }, _toDisplayString(message.name), 9, _hoisted_28),
              _createElementVNode("div", {
                class: "msg-col msg-col-comment",
                title: message.description
              }, _toDisplayString(message.description), 9, _hoisted_29),
              _createElementVNode("div", {
                class: "msg-col msg-col-message",
                title: message.message
              }, _toDisplayString(message.message), 9, _hoisted_30),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    name: "enable",
                    type: "checkbox",
                    checked: message.enabled,
                    disabled: busy.value[message.id],
                    onChange: ($event: any) => (toggleMessage(message))
                  }, null, 40, _hoisted_33)
                ]),
                (busy.value[message.id])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: _normalizeClass(["gorda-status-badge", message.enabled ? 'gorda-status-badge--success' : 'gorda-status-badge--danger'])
                }, _toDisplayString(_ctx.$t(message.enabled ?
                  'common.fields.enabled' : 'common.fields.disabled')), 3)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  class: "settings-icon-btn",
                  "data-bs-toggle": "modal",
                  "data-bs-target": '#' + message.id
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                ]))], 8, _hoisted_36)
              ])
            ], 2))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})